import { Avatar } from '@/components/Avatar/Avatar'
import CloseSvg from '@/icons/close.svg?react'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const GeneratorCommitUI: FunctionalComponent<{
  disabled?: boolean
  commit: string
  onRemove?: () => void
}> = (props) => {
  return (
    <div class={styles.item}>
      <Avatar size={16} />

      <div class={styles.message}>{props.commit}</div>
      <button class={styles.close} onClick={props.onRemove}>
        <CloseSvg />
      </button>
    </div>
  )
}
